module.exports = __webpack_public_path__ + "eda3d05bec9abda0afe627709cee1dd4.svg";